import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent } from './logo-p.svg'

const IconPracticum = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} component={ReactComponent} viewBox="0 0 563 563" sx={{ ...props.sx }}/>
  )
}

export default IconPracticum
